import React from 'react';

export function InviteComposer({
  email,
  inviteRole,
  inviteBusy,
  onEmailChange,
  onRoleChange,
  onSubmit,
  onCancel,
}) {
  return (
    <form className="settings-people__composer" onSubmit={onSubmit}>
      <input
        type="email"
        className="settings-people__field settings-people__input"
        placeholder="name@company.com"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
        autoComplete="off"
        autoFocus
      />
      <select
        className="settings-people__field settings-people__select"
        value={inviteRole}
        onChange={(e) => onRoleChange(e.target.value)}
        aria-label="Role for this invite"
      >
        <option value="user">Member</option>
        <option value="admin">Admin</option>
      </select>
      <button
        type="submit"
        className="settings-modal__action-btn settings-modal__action-btn--primary"
        disabled={!email.trim() || inviteBusy}
      >
        {inviteBusy ? 'Sending…' : 'Send invite'}
      </button>
      <button
        type="button"
        className="settings-modal__action-btn settings-modal__action-btn--ghost"
        disabled={inviteBusy}
        onClick={onCancel}
      >
        Cancel
      </button>
    </form>
  );
}
